import * as RadixSelect from '@radix-ui/react-select';
import classNames from 'classnames';
import React__default from 'react';
import { getPrefixCls } from '../../../utils/getPrefix.js';
import { IconChevronDownSmall } from '../../Icon/IconChevronDownSmall.js';
import '../../../extends-30811c5e.js';
import '../../../defineProperty-6f298737.js';
import '../../../objectWithoutProperties-dd908bcc.js';

var prefixCls = getPrefixCls('select');
var prefixBaseCls = getPrefixCls('input');
var Option = function Option(_ref) {
  var value = _ref.value,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement(RadixSelect.Item, {
    className: "".concat(prefixCls, "_option"),
    value: value
  }, /*#__PURE__*/React__default.createElement(RadixSelect.ItemText, null, children));
};
var Select = function Select(_ref2) {
  var className = _ref2.className,
    defaultValue = _ref2.defaultValue,
    value = _ref2.value,
    label = _ref2.label,
    name = _ref2.name,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'm' : _ref2$size,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? name : _ref2$id,
    onValueChange = _ref2.onValueChange,
    children = _ref2.children,
    disabled = _ref2.disabled,
    _ref2$dataTestid = _ref2.dataTestid,
    dataTestid = _ref2$dataTestid === void 0 ? 'select' : _ref2$dataTestid,
    open = _ref2.open;
  return /*#__PURE__*/React__default.createElement("div", {
    "sl-test-data": dataTestid,
    className: classNames(prefixBaseCls, prefixCls, "".concat(prefixBaseCls, "-").concat(size), "".concat(prefixCls, "-").concat(size), className, {
      'is-disabled': disabled
    })
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: classNames("".concat(prefixBaseCls, "_label ").concat(prefixCls, "_label"))
  }, label), /*#__PURE__*/React__default.createElement(RadixSelect.Root, {
    open: open,
    name: name,
    defaultValue: defaultValue,
    value: value,
    onValueChange: onValueChange
  }, /*#__PURE__*/React__default.createElement(RadixSelect.Trigger, {
    id: id,
    className: "".concat(prefixBaseCls, "_control ").concat(prefixCls, "_control")
  }, /*#__PURE__*/React__default.createElement(RadixSelect.Value, null), /*#__PURE__*/React__default.createElement(IconChevronDownSmall, {
    className: "".concat(prefixBaseCls, "_icon ").concat(prefixCls, "_icon")
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefixCls, "_optionsWrapper")
  }, /*#__PURE__*/React__default.createElement(RadixSelect.Content, {
    className: "".concat(prefixCls, "_options")
  }, /*#__PURE__*/React__default.createElement(RadixSelect.Viewport, null, children)))));
};

export { Option, Select };
